import {
	ChangeDetectionStrategy,
	Component,
	ComponentRef,
	Type,
	ViewContainerRef,
	input,
	viewChild,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
	selector: 'app-mobile-dialog',
	standalone: true,
	imports: [MatDialogModule],
	templateUrl: './mobile-dialog.component.html',
	styleUrl: './mobile-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileDialogComponent {
	viewContainerRef = viewChild.required('dynamicContent', { read: ViewContainerRef });
	footerViewContainerRef = viewChild('footerContent', { read: ViewContainerRef });

	title = input<string>();
	hasFooter = input(false);

	attachFooter<F>(component: Type<F>, data: Record<string, unknown> = {}): ComponentRef<F> {
		const footerRef = this.footerViewContainerRef()!.createComponent(component);

		for (const key in data) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			footerRef.setInput(key, (data as any)[key]);
		}

		return footerRef;
	}
}
